import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HealthService } from 'src/app/pages/privado/services/saude/health.service';
@Component({
  selector: 'app-historico-adesao-plano-saude',
  templateUrl: './historico-adesao-plano-saude.component.html',
  styleUrls: ['./historico-adesao-plano-saude.component.css']
})
export class HistoricoAdesaoPlanoSaudeComponent {
  listaAdesoes: any = [];
  constructor(private healthService: HealthService, private toast: ToastrService) {
    this.healthService.getListBeneficiaryAdesao().subscribe(
      (res: any) => {
        this.listaAdesoes = res;
      }, (err: any) => {
        this.toast.error('Ocorreu um erro!');
      }
    )
  }
}
